module.exports = __webpack_public_path__ + "static/media/img_card_1.d8807485.svg";